import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { getStreak } from "../../functions/getStreak"; 
import { supabase } from "../../supabase";
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader";
import OnlineProjectNavbar from "../../components/common/ProjectNavbar/OnlineProjectNavbar";
import StatsRow from "../../components/projectDetails/statsRow/StatsRow";

import '../../styles/ProjectDetails.css';

export default function OnlineProjectDetails({ user }) {
  const { id } = useParams(); // id projektu w Supabase
  const navigate = useNavigate();

  const [project, setProject] = useState(null);
  const [streak, setStreak] = useState(0);
  const [resultWords, setResultWords] = useState(null);

  

  // Pobranie projektu z Supabase po ID
  useEffect(() => {
    async function fetchProject() {
      const { data, error } = await supabase
        .from("projects")
        .select("*")
        .eq("id", id)
        .single();

      if (error) {
        console.error(error);
        return;
      }
      setProject(data);
      setStreak(getStreak(data.history));
    }

    fetchProject();
  }, [id]);

  if (!project) return <div>Ładowanie projektu...</div>;

  const today = new Date().toISOString().split("T")[0];
  const todayEntry = project.history.find(entry => entry.date === today);
  const TodayWords = todayEntry ? todayEntry.words : 0;
  
  
  // Obliczanie ile słów dziennie
  const howWordsCheck = (e) => {
    e.preventDefault();
    const finishDate = e.target.finishDate.value;
    const diffDays =
      Math.ceil(
        (new Date(finishDate) - new Date(today)) / (1000 * 60 * 60 * 24)) || 1;
    const WordsGoal = project.words;
    const ActualWords = project.actualwords;
    const wordsPerDay = (WordsGoal - ActualWords) / diffDays;
    setResultWords(<h4>Musisz pisać: {wordsPerDay.toFixed(0)} słów dziennie</h4>);
  };

  

  return (
    <div className="project-wrapper">
      <ProjectHeader
        path={'/online'}
        headerTitle={project.title}
        showBackButton={true}
      />
      <div className="project-card">
        <img src = {project.cover} className="project-img"/>
        <progress value={project.actualwords}  max={project.words}> </progress> <br/>
        <h5> {project.actualwords}/{project.words}</h5>
        <h6>{project.description}</h6>
        <StatsRow
            goalEnabled={project.settings.goalEnabled}
            todayWords={TodayWords}
            dailyGoal = {project.settings.dailyGoal}
            streak={streak}/>
      </div>
      
      <OnlineProjectNavbar projectIndex={id}/>
    </div>
  );
}
